// extracted by mini-css-extract-plugin
export var discard = "_6o-3";
export var muiTooltipTooltip = "_6o-5";
export var notificationBar = "_6o-2";
export var saveButtonHoverSlotWrapper = "_6o-4";
export var show = "_6o-1";
export var spacer = "_6o-0";